import { Component } from 'react';

import { OnChangeWithKeyPressType } from 'types/functions';
import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface ToggleButtonProps {
    name?: string;
    className?: string;
    value: boolean;
    onChange?: OnChangeWithKeyPressType;
    disabled?: boolean;
}

interface ToggleButtonState {
    value: boolean;
    keyPress: string | null;
}

class ToggleButton extends Component<ToggleButtonProps, ToggleButtonState> {
    constructor(props: ToggleButtonProps) {
        super(props);
        this.state = {
            keyPress: null,
            value: false,
        };
    }

    static getDerivedStateFromProps(props: ToggleButtonProps, state: ToggleButtonState) {
        if (props.value !== state.value) {
            return {
                value: props.value,
            };
        }
        return null;
    }

    render() {
        // eslint-disable-next-line react/prop-types
        const { className, value, disabled, onChange, name } = this.props;

        return (
            <button
                type="button"
                onClick={(e) => {
                    if (!onChange || disabled) return; // do nothing if no onChange or disabled

                    // Call onChange with the current value toggled
                    // Also pass info about Ctrl and Shift keys
                    onChange(name || '', !value, {
                        ctrl: e.ctrlKey,
                        shift: e.shiftKey,
                    });
                }}
                className={twclsx('w-6', 'h-5', 'cursor-pointer')}
            >
                <Icon className="w-5 h-5">
                    {value ? (
                        <>
                            <div>{value}</div>
                            <path
                                fill={disabled ? '#dddddd' : '#007a63'}
                                d="M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z"
                            />
                            <path fill="none" stroke="none" d="M0 0h24v24H0z" />
                            <path fill="none" stroke="#ffffff" d="M16 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        </>
                    ) : (
                        <>
                            <path
                                fill={disabled ? '#dddddd' : '#fffff'}
                                d="M2 6m0 6a6 6 0 0 1 6 -6h8a6 6 0 0 1 6 6v0a6 6 0 0 1 -6 6h-8a6 6 0 0 1 -6 -6z"
                            />
                            <path fill="none" stroke="none" d="M0 0h24v24H0z" />
                            <path fill="none" stroke="#777777" d="M8 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                        </>
                    )}
                </Icon>
            </button>
        );
    }
}

export default ToggleButton;
